<template>
  <div class="admin-page">
    <div class="admin-toolbar">
      <div class="admin-toolbar__actions">
        <el-button type="primary" :loading="loading" @click="runCheck">立即检测</el-button>
        <span v-if="checkedAt" class="checked-at">上次检测：{{ formatTime(checkedAt) }}</span>
      </div>
      <el-tag v-if="overall" :type="overallTagType" size="large" effect="dark">
        {{ overallLabel }}
      </el-tag>
    </div>

    <el-table :data="items" v-loading="loading" style="width: 100%" row-key="key">
      <el-table-column prop="name" label="依赖项" min-width="200" />
      <el-table-column label="状态" width="110">
        <template #default="scope">
          <el-tag :type="statusTagType(scope.row.status)" size="small">
            {{ statusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="message" label="详情" min-width="320" show-overflow-tooltip />
      <el-table-column label="耗时" width="100">
        <template #default="scope">
          {{ scope.row.latencyMs != null ? `${scope.row.latencyMs} ms` : '—' }}
        </template>
      </el-table-column>
    </el-table>

    <p class="page-hint">
      检测 MySQL、Redis、SMTP 配置与连接、邮件模板、Qdrant、微信应用配置、JWT、IP 库、文件目录与 Ollama 等。
      SMTP 连接测试仅握手，不会发送邮件。
    </p>
  </div>
</template>

<script>
import axios from 'axios'
import { authHeaders } from '@/utils/http'

const STATUS_LABELS = {
  ok: '正常',
  warn: '警告',
  error: '异常',
  skip: '跳过'
}

const OVERALL_LABELS = {
  ok: '全部正常',
  degraded: '部分警告',
  error: '存在异常'
}

export default {
  name: 'AdminDependencyHealthView',
  data() {
    return {
      loading: false,
      overall: '',
      checkedAt: 0,
      items: []
    }
  },
  computed: {
    overallLabel() {
      return OVERALL_LABELS[this.overall] || this.overall || '—'
    },
    overallTagType() {
      if (this.overall === 'ok') return 'success'
      if (this.overall === 'degraded') return 'warning'
      if (this.overall === 'error') return 'danger'
      return 'info'
    }
  },
  mounted() {
    this.runCheck()
  },
  methods: {
    statusLabel(status) {
      return STATUS_LABELS[status] || status
    },
    statusTagType(status) {
      if (status === 'ok') return 'success'
      if (status === 'warn') return 'warning'
      if (status === 'error') return 'danger'
      return 'info'
    },
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(ts * 1000).toLocaleString()
    },
    async runCheck() {
      this.loading = true
      try {
        const { data } = await axios.post('/api/v1/admin/dependencies/health', {}, {
          headers: authHeaders()
        })
        if (data.code !== 200) {
          this.$message.error(data.message || '检测失败')
          return
        }
        const payload = data.data || {}
        this.overall = payload.overall || ''
        this.checkedAt = payload.checkedAt || 0
        this.items = payload.items || []
      } catch (e) {
        this.$message.error(e.response?.data?.message || '检测失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.admin-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.admin-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.checked-at {
  color: #909399;
  font-size: 13px;
}
.page-hint {
  margin-top: 16px;
  color: #909399;
  font-size: 13px;
  line-height: 1.6;
}
</style>
